<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import moment from 'moment';
import { defineComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { authHeader } from "../../helpers/authservice/auth-header";
import axios from 'axios';
import Swal from 'sweetalert2';

const NOVReturnCardList = defineComponent({
  setup() {
    const store = useStore();
    const loading = computed(() => store.state.globals.loading);
    const novReturnCards = computed(() => store.state.novReturnCard.novReturnCards);
    // const rcTemplate = computed(() => store.state.novReturnCard.rcTemplate);
    const pagination = computed(() => store.state.novReturnCard.pagination)
    const title = ref("Print NOV (Return Card)");
    const items = ref([
      {
          text: "Home",
          href: "/"
        },
         {
          text: "Delivery",
        },
        {
          text: "Print NOV (Return Card)",
          active: true,
        }
    ])

    const query = ref({
        search: ''        
    })

    const getNovReturnCards = async (dt) => {
      await store.dispatch('novReturnCard/getNOVReturnCards', {
          page: dt.page,
          pageSize: dt.per_page ,
          sortColumn: 'id',
          search: dt.search,
          orderBy: 'desc'
      });
    }

     const formattedDate = (date) => {
        if (!date) return 'N/A';
        return moment(date).format('YYYY-MM-DD hh:mm A')
    }

    const downloadRCTemplate = async (batch_id, type, location) => {
      if (!batch_id && !type && !location) return;

      store.dispatch('globals/loading', null, { root: true });

      try {
        const { data } = await axios.get('/delivery/print/return-cards', {
          params: {
            batch_id,
            type,
            location
          },
          headers: authHeader()
        })

        if (data) {
          const link= document.createElement('a');
          document.body.appendChild(link);
          link.href = data ;
          link.setAttribute('target', '_blank');
          link.setAttribute('download', 'true');
          link.click();
          store.dispatch('globals/loaded', null, { root: true });
          link.remove();
        } else {
          Swal.fire(
              "Not available", 
              `PDF file not available at the moment`, 
              "success"
          );
          
        }
        store.dispatch('globals/loaded', null, { root: true });
      } catch (err) {
        console.log(err);
        store.dispatch('globals/loaded', null, { root: true });
      }

      // try {
      //   await store.dispatch('novReturnCard/fetchDownloadableRCTemplate', { batch_id, type, location });

      //   await nextTick();
      //   var link= document.createElement('a');
      //   document.body.appendChild(link);
      //   link.href= rcTemplate.value.generated_pdf_file_link ;
      //   link.click();
      //   console.log('test');
      // } catch (err) {
      //   console.log(err);
      // }
    }

    const baseURL = computed(() => axios.defaults.baseURL);

    const markRCAsPrinted = async (batch_id, type, location) => {
      if (!batch_id) return;

      try {
        await store.dispatch('novReturnCard/setRCPrintStatus', { batch_id, type, location } );
      } catch (err) {
        Swal.fire("Failed", `Already printed.`, 'error');
        console.log(err);
      }
    }

    const markNOVAsPrinted = async (batch_id, start, end) => {
      if (!batch_id) return;

      try {
        await store.dispatch('novReturnCard/setNOVPrintStatus', { batch_id, start, end } );
      } catch (err) {
        Swal.fire("Failed", `Already printed.`, 'error');
        console.log(err);
      }
    }

    const syncToLms = async (id) => {
      try{
        store.dispatch('globals/loading', null, { root: true });

        await axios.get(`/lms/?batch_id=${id}`,{
          headers: authHeader()
        }).then(res => {

          store.dispatch('globals/loaded', null, { root: true });
          Swal.fire({
            icon: 'info',
            text: res.data.message,
          })
        });
        
      }catch(error){
        const { message } = error.response.data;
        store.dispatch('globals/loaded', null, { root: true });

        const confirm = await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: message,
        })
        if (confirm.isConfirmed) {
          window.location.reload();
          return;
        }
      }
      
    }

    return {
      getNovReturnCards,
      formattedDate,
      downloadRCTemplate,
      markRCAsPrinted,
      markNOVAsPrinted,
      novReturnCards, 
      title, 
      items, 
      pagination, 
      query,
      loading,
      syncToLms,
      baseURL
    };
  },
  page: {
    title: "Delivery - Print NOV (Return Card)",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
    TableBody,
    TableHead,
    TableBodyCell
  }
});

export default NOVReturnCardList;
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="loading">
    <div class="d-flex mb-4 justify-content-between">
      <div>
        <h1 class="fs-4 text">Print NOV (Return Card) List</h1>
        <small>Lists of all NOV (Return Card)</small>
      </div>
    </div>

    <div class="row">
        <div class="col lg-12">
            <data-table :rows="novReturnCards"
                :pagination="pagination"
                striped
                :loading="loading"
                :query="query"
                filter
                hoverable
                sortable
                @loadData="getNovReturnCards"
            >
              <template #thead>
                  <table-head>Batch ID</table-head>
                  <table-head>Batch No.</table-head>
                  <table-head>Batch Date</table-head>
                  <table-head>Batch Count</table-head>
                  <!-- <table-head>Print Status</table-head> -->
                  <table-head>Print</table-head>
              </template>

              <template #tbody="{row}">
                  <table-body v-text="row.id"/>
                  <table-body v-text="row.batch_number"/>
                  <table-body v-text="formattedDate(row.created_at)" />
                  <table-body v-text="row.batch_count" />
                  <table-body>
                    <div class="mb-2">
                      <div class="mb-1" v-if="row.batch_return_cards && row.batch_return_cards.length">
                        <b-button-group class="mx-1">
                          <a class="btn btn-secondary" :href="`${baseURL}/delivery/print/return-cards?batch_id=${row.id}&type=philpost&location=mm`" download="true">PhilPost RC Template (MM)</a>
                          <b-dropdown right text="" variant="secondary">
                            <b-dropdown-item>
                              <div class="form-check form-switch form-check-inline" dir="ltr">
                                <input @click="markRCAsPrinted(row.id, 'philpost', 'mm')" :disabled="row.batch_return_cards[2].is_printed" :checked="row.batch_return_cards[2].is_printed" type="checkbox" class="form-check-input" :id="`inlineswitch-${row.batch_return_cards[2].id}`">
                                <label class="form-check-label fs-6 text" :for="`inlineswitch-${row.batch_return_cards[2].id}`">{{ !row.batch_return_cards[2].is_printed ? 'Mark as Printed' : 'Printed' }}</label>
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-button-group>

                        <b-button-group class="mx-1">
                          <a :href="`${baseURL}/delivery/print/return-cards?batch_id=${row.id}&type=philpost&location=outside_mm`" download="true" class="btn btn-secondary">PhilPost RC Template (Outside MM)</a>
                          <b-dropdown right text="" variant="secondary">
                            <b-dropdown-item>
                              <div class="form-check form-switch form-check-inline" dir="ltr">
                                <!-- <input @click="markRCAsPrinted(row.id, 'philpost', 'outside_mm')" :disabled="row.batch_return_cards[3].is_printed" :checked="row.batch_return_cards[3].is_printed" type="checkbox" class="form-check-input" :id="`inlineswitch-${row.batch_return_cards[3].id}`">
                                 <label class="form-check-label fs-6 text" :for="`inlineswitch-${row.batch_return_cards[3].id}`">{{ !row.batch_return_cards[3].is_printed ? 'Mark as Printed' : 'Printed' }}</label> -->
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-button-group>
                      </div>

                      <div class="mb-1">
                        <b-button-group class="mx-1">
                          <a :href="`${baseURL}/delivery/print/return-cards?batch_id=${row.id}&type=qpax&location=mm`" download="true" class="btn btn-secondary">QPAX RC Template (MM)</a>
                          <b-dropdown right text="" variant="secondary">
                            <b-dropdown-item>
                              <div class="form-check form-switch form-check-inline" dir="ltr">
                                <input @click="markRCAsPrinted(row.id, 'qpax', 'mm')" :disabled="row.batch_return_cards[0].is_printed" :checked="row.batch_return_cards[0].is_printed" type="checkbox" class="form-check-input" :id="`inlineswitch-${row.batch_return_cards[0].id}`">
                                <label class="form-check-label fs-6 text" :for="`inlineswitch-${row.batch_return_cards[0].id}`">{{ !row.batch_return_cards[0].is_printed ? 'Mark as Printed' : 'Printed' }}</label>
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-button-group>

                        <b-button-group class="mx-1">
                          <a :href="`${baseURL}/delivery/print/return-cards?batch_id=${row.id}&type=qpax&location=outside_mm`" download="true" class="btn btn-secondary">QPAX RC Template (Outside MM)</a>
                          <b-dropdown right text="" variant="secondary">
                            <b-dropdown-item>
                              <div class="form-check form-switch form-check-inline" dir="ltr">
                                <input @click="markRCAsPrinted(row.id, 'qpax', 'outside_mm')" :disabled="row.batch_return_cards[1].is_printed" :checked="row.batch_return_cards[1].is_printed" type="checkbox" class="form-check-input" :id="`inlineswitch-${row.batch_return_cards[1].id}`">
                                <label class="form-check-label fs-6 text" :for="`inlineswitch-${row.batch_return_cards[1].id}`">{{ !row.batch_return_cards[1].is_printed ? 'Mark as Printed' : 'Printed' }}</label>
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-button-group> 
                      </div>
                    </div>
                    <div class="d-flex flex-wrap" v-if="row.batch_notice_of_violations.length">
                      <span v-for="(nov) in row.batch_notice_of_violations" :key="nov.id">
                        <b-button-group class="mx-1">
                          <a download="true" :href="`${baseURL}/delivery/print/novs?batch_id=${row.id}&start=${nov.start}&end=${nov.end}`"  class="btn btn-success">NOV ({{ `${nov.start}-${nov.end}` }})</a>
                          <b-dropdown right text="" variant="success">
                            <b-dropdown-item>
                              <div class="form-check form-switch form-check-inline" dir="ltr">
                                <input @click="markNOVAsPrinted(row.id, nov.start, nov.end)" :disabled="nov.is_printed" :checked="nov.is_printed" type="checkbox" class="form-check-input"  :id="`inlineswitch-${nov.id}-${nov.start}-${nov.end}`">
                                <label class="form-check-label fs-6 text" :for="`inlineswitch-${nov.id}-${nov.start}-${nov.end}`">{{ !nov.is_printed ? 'Mark as Printed' : 'Printed' }}</label>
                              </div>
                            </b-dropdown-item>
                          </b-dropdown>
                        </b-button-group> 
                      </span>
                      <span>
                        <b-button-group class="mx-1">
                          <button @click.prevent="syncToLms(row.id)" type="button" class="btn btn-success">Sync to LMS</button>
                          <!-- <a :href="`${baseURL}/lms?batch_id=${row.id}`"  class="btn btn-success">Sync to LMS</a> -->
                        </b-button-group> 
                      </span>
                    </div>
                  </table-body>
              </template>

              <template #empty>
                <TableBodyCell colspan="5">
                    No NOV return cards found.
                </TableBodyCell>
            </template>
          </data-table>
        </div>
      </div>
      </b-overlay>
  </Layout>
</template>